/**
 * URL of short looping video to be used as a placeholder. Should be blurred.
 * @type {String} URL
 */
// eslint-disable-next-line import/prefer-default-export
export const VIDEO_PREVIEW_URL = 'https://static.tryexponent.com/expert_answer_placeholder_3fdfaac7d5.mp4';
